(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["click-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('click-bundle')) return;

    class ClickBundle extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section, dialog') || document;
        this.addEventListener('change', this.apply);
        this.scope.addEventListener('shopify:product:select', this.onProductSelect);
        this.ensureSelection();
        this.apply();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.apply);
        this.scope?.removeEventListener('shopify:product:select', this.onProductSelect);
      }

      ensureSelection() {
        const checked = this.querySelector('.click-bundle__input:checked');
        if (checked && !checked.disabled) return;
        const first = this.querySelector('.click-bundle__input:not(:disabled)');
        if (first) first.checked = true;
      }

      // Copy the selected offer's quantity into the product form.
      apply = () => {
        const input = this.querySelector('.click-bundle__input:checked');
        const form = this.scope.querySelector('product-form-component form, form[data-type="add-to-cart-form"]');
        if (!input || !form) return;

        let quantity = form.querySelector('input[name="quantity"]');
        if (!quantity) {
          quantity = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' });
          form.append(quantity);
        }
        quantity.value = input.dataset.quantity;
      };

      // Horizon re-renders the section on variant change: take the new prices from it.
      onProductSelect = (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        event.promise
          ?.then(({ detail }) => {
            // Wait for the product form to finish its own update, which resets the quantity.
            setTimeout(() => {
              if (detail?.html) this.refresh(detail.html);
              this.apply();
            });
          })
          .catch(() => {});
      };

      refresh(html) {
        for (const option of this.querySelectorAll('[data-click-bundle-option]')) {
          const fresh = html.querySelector(`[data-click-bundle-option="${option.dataset.clickBundleOption}"]`);
          if (!fresh) continue;

          const input = option.querySelector('.click-bundle__input');
          input.disabled = fresh.querySelector('.click-bundle__input').disabled;

          for (const child of [...option.children]) if (child !== input) child.remove();
          for (const child of [...fresh.children]) if (!child.matches('.click-bundle__input')) option.append(child);
        }
        this.ensureSelection();
      }
    }

    customElements.define('click-bundle', ClickBundle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["click-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('click-delivery-estimate')) return;

    const DAY = 86400000;

    // Cairo wall-clock time as a "fake UTC" timestamp, so date math ignores the device timezone.
    const cairoParts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Africa/Cairo',
      hourCycle: 'h23',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });

    function cairoNow() {
      const p = {};
      for (const { type, value } of cairoParts.formatToParts(new Date())) p[type] = Number(value);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    }

    const pad = (n) => String(n).padStart(2, '0');

    class ClickDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.cutoffHour = Number(d.cutoffHour) || 15;
        this.shipDays = Number(d.shipDays) || 0;
        this.minDays = Number(d.minDays) || 2;
        this.maxDays = Math.max(Number(d.maxDays) || 3, this.minDays);
        this.skipFriday = d.skipFriday === 'true';

        this.timerEl = this.querySelector('[data-click-ship-timer]');
        this.dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          timeZone: 'UTC',
          day: 'numeric',
          month: 'short',
        });

        this.update();

        this.visible = false;
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);

        this.onVisibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      isWorkday(dayStart) {
        return !(this.skipFriday && new Date(dayStart).getUTCDay() === 5);
      }

      addWorkdays(dayStart, count) {
        let day = dayStart;
        let added = 0;
        while (added < count) {
          day += DAY;
          if (this.isWorkday(day)) added++;
        }
        return day;
      }

      // Tick once per second, only while the block is on screen and the tab is visible.
      schedule() {
        clearTimeout(this.timeout);
        if (!this.visible || document.hidden) return;
        this.timeout = setTimeout(() => {
          this.update();
          this.schedule();
        }, 1000 - (Date.now() % 1000));
      }

      update() {
        const now = cairoNow();
        const today = now - (now % DAY);

        // Next cutoff that falls on a workday and is still ahead of us.
        let dispatchDay = today;
        while (!this.isWorkday(dispatchDay) || now >= dispatchDay + this.cutoffHour * 3600000) {
          dispatchDay += DAY;
        }

        const diff = dispatchDay + this.cutoffHour * 3600000 - now;
        if (this.timerEl) {
          const s = Math.floor(diff / 1000);
          this.timerEl.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
        }

        // Dates only change at a new day or a passed cutoff.
        const key = `${today}-${dispatchDay}`;
        if (key === this.datesKey) return;
        this.datesKey = key;

        const shipped = this.addWorkdays(dispatchDay, this.shipDays);
        const from = this.addWorkdays(dispatchDay, this.minDays);
        const to = this.addWorkdays(dispatchDay, this.maxDays);

        this.setText('[data-click-ship-ordered]', this.dateFormat.format(today));
        this.setText('[data-click-ship-shipped]', this.dateFormat.format(shipped));
        this.setText('[data-click-ship-arriving]', this.range(from, to));
        this.setText('[data-click-ship-window]', this.range(from, to));
      }

      range(from, to) {
        if (from === to) return this.dateFormat.format(from);
        return this.dateFormat.formatRange
          ? this.dateFormat.formatRange(from, to)
          : `${this.dateFormat.format(from)} – ${this.dateFormat.format(to)}`;
      }

      setText(selector, text) {
        const el = this.querySelector(selector);
        if (el) el.textContent = text;
      }
    }

    customElements.define('click-delivery-estimate', ClickDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wbi-product-upsell"] && !Shopify.designMode) return;
  try {
    ;(() => {
  if (window.wbiPuInit) return;
  window.wbiPuInit = true;

  const TAG = 'wbi-product-upsell';
  const ADDED_MS = 1600;
  const SWIPE_MIN = 35;
  const OPEN_DELAY = 600;

  const openCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  };

  const cartAddUrl = () => `${window.Shopify?.routes?.root || '/'}cart/add.js`;

  const cartSectionIds = () => {
    const ids = [];
    for (const node of document.querySelectorAll('cart-items-component[data-section-id]')) {
      const id = node.dataset.sectionId;
      if (id && !ids.includes(id)) ids.push(id);
    }
    return ids;
  };

  const announce = (host, message) => {
    const region = host.querySelector('[data-wbi-pu-live]');
    if (region && message) {
      region.textContent = '';
      region.textContent = message;
    }
  };

  const slides = (host) => host.querySelectorAll('.wbi-pu__slide');

  function goTo(host, index) {
    const track = host.querySelector('.wbi-pu__track');
    const all = slides(host);
    if (!track || !all.length) return;

    const cursor = Math.max(0, Math.min(index, all.length - 1));
    host.dataset.wbiPuCursor = cursor;

    const rtl = getComputedStyle(host).direction === 'rtl';
    track.style.transform = `translateX(${cursor * (rtl ? 100 : -100)}%)`;

    const prev = host.querySelector('[data-wbi-pu-prev]');
    const next = host.querySelector('[data-wbi-pu-next]');
    if (prev) prev.disabled = cursor === 0;
    if (next) next.disabled = cursor >= all.length - 1;
  }

  const cursorOf = (host) => Number(host.dataset.wbiPuCursor) || 0;

  function onVariantChange(select) {
    const item = select.closest('.wbi-pu__slide');
    const option = select.selectedOptions[0];
    if (!item || !option) return;

    const price = item.querySelector('[data-wbi-pu-price]');
    const compare = item.querySelector('[data-wbi-pu-compare]');
    const badge = item.querySelector('[data-wbi-pu-badge]');
    const button = item.querySelector('[data-wbi-pu-add]');

    if (price) {
      price.textContent = option.dataset.price || price.textContent;
      price.classList.toggle('wbi-pu__price--on-sale', Boolean(option.dataset.compare));
    }
    if (compare) {
      const value = option.dataset.compare || '';
      compare.textContent = value;
      compare.hidden = value === '';
    }
    if (badge) {
      const discount = option.dataset.discount || '';
      badge.textContent = discount ? `-${discount}%` : '';
      badge.hidden = discount === '';
    }
    if (button) {
      button.dataset.wbiPuVariant = option.value;
      button.toggleAttribute('disabled', option.dataset.available !== 'true');
    }
  }

  const dispatchCartUpdate = (host, variantId, promise) => {
    const event = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
    event.action = 'add';
    event.context = 'cart';
    event.lines = [{ merchandiseId: variantId, quantity: 1 }];
    event.promise = promise;
    host.dispatchEvent(event);
  };

  async function addToCart(host, button) {
    if (button.hasAttribute('disabled')) return;

    const variantId = button.dataset.wbiPuVariant;
    if (!variantId) return;

    const slide = button.closest('.wbi-pu__slide');
    const error = slide?.querySelector('[data-wbi-pu-error]');

    if (error) error.textContent = '';
    button.setAttribute('disabled', '');
    button.dataset.state = 'loading';

    const sections = cartSectionIds();
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sections.length) body.sections = sections.join(',');

    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const payload = await response.json();
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || host.dataset.errorText);
      }

      await new Promise((resolve) => setTimeout(resolve, OPEN_DELAY));

      const settled = Promise.resolve({
        cart: null,
        detail: { didError: false, sections: payload.sections, source: TAG },
      });
      dispatchCartUpdate(host, variantId, settled);
      openCartDrawer();

      button.dataset.state = 'added';
      announce(host, host.dataset.addedText);

      setTimeout(() => {
        if (button.isConnected) delete button.dataset.state;
      }, ADDED_MS);
    } catch (reason) {
      delete button.dataset.state;

      const message = reason?.message || host.dataset.errorText;
      if (error) error.textContent = message;
      announce(host, message);
    } finally {
      if (button.isConnected) button.removeAttribute('disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const nav = event.target.closest('[data-wbi-pu-prev], [data-wbi-pu-next]');
    if (nav) {
      const host = nav.closest(TAG);
      if (host) goTo(host, cursorOf(host) + (nav.hasAttribute('data-wbi-pu-prev') ? -1 : 1));
      return;
    }
    const button = event.target.closest('[data-wbi-pu-add]');
    if (button) {
      event.preventDefault();
      const host = button.closest(TAG);
      if (host) addToCart(host, button);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-wbi-pu-variants]');
    if (select) onVariantChange(select);
  });

  let touchX = 0;
  let touchY = 0;
  let touchHost = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      const stage = event.target instanceof Element && event.target.closest('.wbi-pu--slider .wbi-pu__stage');
      touchHost = stage ? stage.closest(TAG) : null;
      if (!touchHost) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      if (!touchHost) return;
      const host = touchHost;
      touchHost = null;
      const dx = touchX - event.changedTouches[0].clientX;
      const dy = touchY - event.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_MIN) {
        const rtl = getComputedStyle(host).direction === 'rtl';
        const forward = rtl ? dx < 0 : dx > 0;
        goTo(host, cursorOf(host) + (forward ? 1 : -1));
      }
    },
    { passive: true }
  );

  function wheelNav(host, event) {
    const all = slides(host);
    if (all.length < 2) return;

    const delta = Math.abs(event.deltaX) >= Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (Math.abs(delta) < 2) return;

    const target = cursorOf(host) + (delta > 0 ? 1 : -1);
    if (target < 0 || target >= all.length) return;

    event.preventDefault();
    const now = Date.now();
    if (now < (host.wbiWheelLock || 0)) return;
    host.wbiWheelLock = now + 320;
    goTo(host, target);
  }

  if (!customElements.get(TAG)) {
    customElements.define(
      TAG,
      class extends HTMLElement {
        connectedCallback() {
          if (!this.classList.contains('wbi-pu--slider')) return;
          const stage = this.querySelector('.wbi-pu__stage');
          if (!stage) return;
          this.wbiStage = stage;
          this.wbiWheel = (event) => wheelNav(this, event);
          stage.addEventListener('wheel', this.wbiWheel, { passive: false });
        }

        disconnectedCallback() {
          if (this.wbiStage && this.wbiWheel) {
            this.wbiStage.removeEventListener('wheel', this.wbiWheel);
          }
        }
      }
    );
  }
})();
  } catch(e) { console.error(e); }
})();

})();
